import { useTimeDisplay } from "../../../../utils/TimeDisplay";
import { useEffect } from "react";
import { useDateDifferenceInSeconds } from "./useDateDifferenceInSeconds";
import { useNotificationStore } from "../../../Store/NotificationStore";
import { useParseTimeToSeconds } from "./useParseTimeToSeconds";

type Props = {
	progress: number | null;
	data: unknown;
	startedAt: string;
	endedAt: string;
	isDone: boolean;
	reRenderFunction: () => Promise<void>;
	setLoading?: (loading: boolean) => void;
	setIsDone: (isDone: boolean) => void;
	setProgress: (progress: number) => void;
};

export const useUpdateProgressBar = ({
	progress,
	data,
	startedAt,
	endedAt,
	isDone,
	reRenderFunction,
	setLoading,
	setIsDone,
	setProgress,
}: Props) => {
	const setNotification = useNotificationStore(state => state.setNotification);

	console.log("PROGRESS", progress);

	console.log("EXPEDITION", data);

	const { timeLeft } = useTimeDisplay(endedAt);

	console.log("timeLeft", timeLeft);

	console.log("expeditionIsDone", isDone);

	useEffect(() => {
		if (progress === 100 && isDone) {
			if (setLoading) {
				setLoading(true);
			}
			setTimeout(async () => {
				try {
					console.log("reRenderFunction");
					await reRenderFunction();
				} catch (e) {
					setNotification({
						type: "Error",
						message:
							"Ошибка при завершении экспедиции. Попробуйте позже. Все ваши награды будут сохранены",
					});
				}
			}, 5000);
		}
	}, [progress, isDone]);

	useEffect(() => {
		const totalDurationInSeconds = useDateDifferenceInSeconds(
			startedAt,
			endedAt
		);

		const update = () => {
			const timeInSeconds = useParseTimeToSeconds(timeLeft as string);
			const progressRatio = 1 - timeInSeconds / totalDurationInSeconds;

			let pct = 22 + 78 * progressRatio;

			setProgress(pct);
		};

		update();
		const interval = setInterval(update, 1000);

		return () => clearInterval(interval);
	}, [timeLeft]);

	useEffect(() => {
		if (progress && progress > 97 && progress < 100) {
			setIsDone(true);
		}
	}, [progress]);

	return {
		updatedProgressBar: progress,
	};
};
